// Les lectures du panier (GET checkout, GET cart) et les modifications du checkout partent en
// parallèle depuis la page de livraison, le CartManager et le panier. Sans garde, une réponse lente
// écrase un panier plus récent et laisse affichés d'anciens frais de livraison (TIC-428).

let cartVersion = 0
let checkoutMutationQueue: Promise<unknown> = Promise.resolve()

/**
 * Exécute les modifications du checkout l'une après l'autre, dans l'ordre d'appel : deux changements
 * de livraison successifs ne peuvent plus être traités dans le désordre par Sylius. Toute lecture du
 * panier lancée avant le début de la modification devient périmée.
 */
export function enqueueCheckoutMutation<T>(
  mutation: () => Promise<T>
): Promise<T> {
  const run = checkoutMutationQueue.then(() => {
    cartVersion++
    return mutation()
  })
  checkoutMutationQueue = run.catch(() => undefined)
  return run
}

/**
 * Démarre une lecture du panier une fois les modifications en attente terminées. Le retour indique,
 * à l'arrivée de la réponse, si elle reflète encore le dernier état connu ; sinon elle doit être ignorée.
 */
export async function beginCartRead(): Promise<() => boolean> {
  await checkoutMutationQueue
  const version = ++cartVersion
  return () => version === cartVersion
}
